module.exports = __webpack_public_path__ + "img/76264.9e568e77.svg";